import { Injectable } from '@angular/core';
import { AnzNavLinksService, staticPages } from './anz-nav-links.service';

@Injectable({
  providedIn: 'root',
})
export class AnzBizNavLinksService extends AnzNavLinksService {
  staticPages = [
    ...staticPages,
    {
      translationKey: 'wl.anz.header.anz_link',
      route: 'https://www.anz.com.au/business/',
    },
  ];
}
